import { styled } from "@mui/material";
import { useState } from "react";
import { TopBanner } from "./top-banner/TopBanner";
import { MeetingRoom } from "@kaltura/mediaspace-shared-meeting-room";
import { HeroLayout, HeroLayoutMode } from "@kaltura/mediaspace-shared-layout";
import { translate } from "@kaltura/mediaspace-shared-utils";
import StudioWelcomeManager from "./welcome/StudioWelcomeManager";

const StyledLiveStudio = styled("div")(({ theme }) => ({
    display: "flex",
    flexDirection: "column",
    width: "100%",
}));

interface LiveStudioProps {
    /**
     * url of the action that shows the room (launch)
     */
    roomUrl: string;
    /**
     * entry/event name to display in the top banner
     */
    eventName: string;
}

/**
 * Studio view for live-studio entries
 */
export function LiveStudio({ roomUrl, eventName }: LiveStudioProps) {
    const [isTopBannerVisible, setIsTopBannerVisible] = useState(true);

    // add "mode=attendee" to the current URL (entry page url) to generate the attendee view URL
    const getAttendeeViewUrl = () => {
        const url = new URL(document.location.href);
        url.searchParams.set("mode", "attendee");
        return url.toString();
    };

    return (
        <StyledLiveStudio>
            {isTopBannerVisible && (
                <TopBanner
                    bannerText={translate("This is webcast studio for: %1", [eventName])}
                    buttonText={translate("Attendee view")}
                    buttonUrl={getAttendeeViewUrl()}
                    buttonTarget="_blank"
                    onClose={() => setIsTopBannerVisible(false)}
                    ctaAnalyticsValue={"Attendee View"}
                    closeButtonAnalyticsValue={"Close Live studio banner"}
                />
            )}
            <HeroLayout mode={HeroLayoutMode.FullSize} marginBottom={isTopBannerVisible ? "50px" : "0px"}>
                <MeetingRoom roomUrl={roomUrl} title={translate("Live Studio")} />
            </HeroLayout>

            <StudioWelcomeManager />
        </StyledLiveStudio>
    );
}

export default LiveStudio;
